import type { SidePanel } from '../types';

export const InvestBuy: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./InvestBuyPanel.vue')),
};
